import React, { useState } from "react";
import { Grid, TextField, Button, Typography, Paper, Box, Card } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { motion, AnimatePresence } from "framer-motion";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";

const CreateAdmin = () => {
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone_no: "",
    });
    const navigate = useNavigate();

    const [errors, setErrors] = useState({});
    const [showCard, setShowCard] = useState(true);
    const API_URL = process.env.REACT_APP_API_DJANGO_URL;

    const nameRegex = /^[A-Za-z]{2,20}$/;
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailRegex = /^(?=.{2,50}$)[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

    const phoneRegex = /^[6-9]\d{9}$/;

    const handleChange = (e) => {
    let { name, value } = e.target;

    // ✅ Names: only alphabets
    if (name === "first_name" || name === "last_name") {
        value = value.replace(/[^A-Za-z]/g, "");
    }

    // ✅ Email: remove starting spaces
    if (name === "email") {
        value = value.replace(/^\s+/, "").toLowerCase();
    }

    // ✅ Phone: only digits, max 10
    if (name === "phone_no") {
        value = value.replace(/\D/g, "").slice(0, 10);
    }

    setFormData((prev) => ({
        ...prev,
        [name]: value,
    }));

    // ✅ Real-time validation
    let error = "";

    if (name === "first_name") {
        if (!value) error = "First name is required";
        else if (!nameRegex.test(value)) error = "Only alphabets (2–20)";
    }

    if (name === "last_name") {
        if (!value) error = "Last name is required";
        else if (!nameRegex.test(value)) error = "Only alphabets (2–20)";
    }

    if (name === "email") {
    if (!value) {
        error = "Email is required";
    } else if (value.length < 2 || value.length > 50) {
        error = "Email must be 2–50 characters";
    } else if (!emailRegex.test(value)) {
        error = "Invalid email format";
    }
}
    if (name === "phone_no") {
        if (value && !phoneRegex.test(value)) {
            error = "Must be 10 digits & start 6–9";
        }
    }

    setErrors((prev) => ({
        ...prev,
        [name]: error,
    }));
};

    const validateForm = () => {
    const tempErrors = {};

    const firstName = formData.first_name.trim();
    const lastName = formData.last_name.trim();
    const email = formData.email.trim();
    const phone = formData.phone_no.trim();

    // ✅ First Name
    if (!firstName) {
        tempErrors.first_name = "First name is required";
    } else if (!nameRegex.test(firstName)) {
        tempErrors.first_name = "Only alphabets, 2–20 characters";
    }

    // ✅ Last Name
    if (!lastName) {
        tempErrors.last_name = "Last name is required";
    } else if (!nameRegex.test(lastName)) {
        tempErrors.last_name = "Only alphabets, 20 characters";
    }

    // ✅ Email
    if (!email) {
    tempErrors.email = "Email is required";
} else if (email.length < 2 || email.length > 50) {
    tempErrors.email = "Email must be 2–50 characters";
} else if (!emailRegex.test(email)) {
    tempErrors.email = "Invalid email format";
}
    // ✅ Phone
    if (!phone) {
        tempErrors.phone_no = "Phone number is required";
    } else if (!phoneRegex.test(phone)) {
        tempErrors.phone_no = "Must be 10 digits & start from 6–9";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
};

    const generatePassword = (length = 10) => {
        const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
        let password = "";
        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return password;
    };
    const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
        const token = localStorage.getItem("accessToken");

        // ✅ Generate password
        // const generatedPassword = generatePassword();

        const payload = {
            ...formData,
            // password: generatedPassword,
        };

        await axios.post(
            `${API_URL}/api/create_admin/`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",            // ✅ REQUIRED
                    "Content-Type": "application/json",    // ✅ REQUIRED
                },
            }
        );

        toast.success(`Admin created sucessfully!`);

        setFormData({
            first_name: "",
            last_name: "",
            email: "",
            phone_no: "",
        });

    } catch (error) {
        toast.error(error.response?.data?.error || "Failed to create admin");
    }
};
    return (
        <Box
            className="manage-site-wrapper"
            sx={{ maxWidth: 1500, mx: "auto", py: 4, px: 2 }}
        >
            <AnimatePresence>
                {showCard && (
                    <motion.div
                        key="create-admin-card"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.5 }}
                        // Added display flex here to center the Paper inside the motion div
                        style={{ display: "flex", justifyContent: "center" }}
                    >
                     
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 4,
                                    borderRadius: 3,
                                    border: "1px solid #ccc",
                                    backgroundColor: "#fff",
                                    // Removed display: inline-block to allow standard centering
                                    maxWidth: "450px",
                                    width: "100%"
                                }}
                            >
                                <form onSubmit={handleSubmit}>
                                    <Grid container direction="column" spacing={2} alignItems="center">
                                        {["first_name", "last_name", "email", "phone_no"].map((field) => (
                                            <Grid item key={field} sx={{ width: "100%" }}>
                                                <TextField
                                                    fullWidth
                                                    label={field.replace("_", " ").replace(/\b\w/g, c => c.toUpperCase())}
                                                    name={field}
                                                    required
                                                    value={formData[field]}
                                                    onChange={handleChange}
                                                    error={!!errors[field]}
                                                    helperText={errors[field]}
                                                    sx={{
                                                        minWidth: { xs: "250px", sm: "300px", md: "350px" },
                                                    }}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>

                                    <Box
                                        sx={{
                                            mt: 3,
                                            display: "flex",
                                            justifyContent: "flex-end", // Aligns buttons to the right
                                            gap: 2,
                                            width: "100%",
                                        }}
                                    >
                                        <Button
                                            variant="outlined"
                                            // onClick={() => window.history.back()}
                                            onClick={() => navigate("/dashboard")}
                                            sx={{
                                                textTransform: "none",
                                                px: 3,
                                                borderRadius: "5px", // Makes the button borders curved
                                                borderWidth: "1px",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    backgroundColor: "rgba(25, 118, 210, 0.04)", // Light blue tint on hover
                                                    borderColor: "#115293",
                                                    transform: "translateY(-2px)", // Subtle lift effect
                                                },
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            sx={{
                                                textTransform: "none",
                                                px: 3,
                                                borderRadius: "5px", // Makes the button borders curved
                                                backgroundColor: "#1976d2",
                                                transition: "all 0.3s ease",
                                                "&:hover": {
                                                    backgroundColor: "#115293", // Darker blue on hover
                                                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Shadow depth on hover
                                                    transform: "translateY(-2px)", // Subtle lift effect
                                                },
                                            }}
                                        >
                                            Create Admin
                                        </Button>
                                    </Box>
                                </form>
                            </Paper>
                      
                    </motion.div>
                )}
            </AnimatePresence>

            <ToastContainer position="top-right" autoClose={3000} />
        </Box>
    );
};

export default CreateAdmin;